module.exports = __webpack_public_path__ + "img/opening-center.0f66b413.svg";